export const COLOR_BLUE = '#448afc'

export const COLOR_WARNING = '#ff8c30'

export const COLOR_SUCCESS = '#2fc286'

export const COLOR_ERROR = '#ff5c5c'

export const COLOR_ORANGE = '#FF801A'

export const COLOR_GREEN = '#47D788'

export const COLOR_LIST = [
  '#448AFC',
  '#C888F8',
  '#FF70CE',
  '#5DC2FC',
  '#46D787',
  '#FFD21B',
  '#FFAF24'
]
